export default __webpack_public_path__ + "static/media/Bloodseraph's Helm.d4036665.jpg";